/**
 * Compartment list behavior — how the compartments list renders and behaves
 * depending on the active product view mode.
 *
 * - SELECT:      standard mode — tiles show name + area, click = select + expand details
 * - ARRANGE:     variant cycling mode — tiles show name + "selected / total", click = cycle variant
 * - AXONOMETRIC: placeholder — renders like SELECT until axonometric behavior is defined
 *
 * Assigned per-mode in PRODUCT_MODE_REGISTRY (modeRegistry.js).
 * Consumed by CompartmentsList to switch rendering logic without mode-specific branches.
 */

export const COMPARTMENT_LIST_BEHAVIOR = {
  SELECT:      'select',
  ARRANGE:     'arrange',
  AXONOMETRIC: 'axonometric',
}
